function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { Button, Grid, GridItem, TextButton, Typography } from 'seagull';
import { useStore } from "../../../contexts";
import { usePaymentMethodLearnMoreModal } from "../../../components/PaymentMethodLearnMoreModal/usePaymentMethodLearnMoreModal";
import BankSecurityRow from "../../../components/BankSecurityRow/BankSecurityRow";
import StripeElementsProvider from "../../../providers/StripeElementsProvider";
import { selectors } from "../../../store/state-selectors";
import MinisiteTabHeader from "../MinisiteTabHeader/MinisiteTabHeader";
import styles from "./PaymentMethods.module.scss";
import ManagePaymentMethods from "../../../components/ManagePaymentMethods/ManagePaymentMethods";
import { relationshipModel } from "../../../models";
import { useRequestPM } from "../../../hooks/useRequestPaymentMethod";
export default function PaymentMethods(props) {
  const {
    isVendor,
    agreement,
    onRefreshAgreement
  } = props;
  const isMemberUser = useStore(selectors.user.isMemberUser);
  const isAccountant = useStore(selectors.user.isAccountant);
  const isMemberClient = !isVendor && isMemberUser;
  const openLearnMoreModal = usePaymentMethodLearnMoreModal();
  const requestPm = useRequestPM();
  const [isAddingAnotherPaymentMethod, setIsAddingAnotherPaymentMethod] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MinisiteTabHeader, {
    "data-testid": "payment-methods-page-header",
    text: /*#__PURE__*/React.createElement(React.Fragment, null, "Payment Methods", /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph2"
    }, 'Manage payment methods for this agreement. ', /*#__PURE__*/React.createElement(TextButton, {
      onClick: openLearnMoreModal
    }, "Learn more"))),
    actions: /*#__PURE__*/React.createElement("div", {
      className: styles.actionButtonsContainer
    }, isVendor && /*#__PURE__*/React.createElement(Button, {
      skin: 'primaryOutlineOpaque',
      "data-testid": 'request-payment-method-btn',
      onClick: () => requestPm(agreement.id)
    }, "Request payment method"), /*#__PURE__*/React.createElement(Button, {
      skin: "primary",
      "data-testid": "add-payment-method-btn",
      onClick: () => setIsAddingAnotherPaymentMethod(true)
    }, "Add payment method"))
  }), /*#__PURE__*/React.createElement(Grid, null, !relationshipModel.isTerminated(agreement) && /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(StripeElementsProvider, null, /*#__PURE__*/React.createElement(ManagePaymentMethods, _extends({
    isAddingAnotherPaymentMethod: isAddingAnotherPaymentMethod,
    setIsAddingAnotherPaymentMethod: setIsAddingAnotherPaymentMethod,
    isVendorCoveringFees: relationshipModel.actualIsVendorCoveringCCFee(agreement),
    vendorId: relationshipModel.vendor(agreement),
    customerId: relationshipModel.customer(agreement),
    showCreditCardFee: !relationshipModel.isVendorCoveringCCFee(agreement),
    isProposal: false,
    isPreview: false,
    isSample: relationshipModel.isSample(agreement),
    isMemberClient: isMemberClient,
    hideInviteMemberHint: isVendor,
    isInviteMemberDisabled: isAccountant || relationshipModel.isSample(agreement),
    relationshipId: relationshipModel.id(agreement),
    onPaymentMethodUpdated: () => onRefreshAgreement({
      silent: true
    }),
    hideExpandableAddPmButton: true
  }, props)))), /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(BankSecurityRow, null))));
}